import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {SearchPaginatedAdxBookingToTramsInvoiceLinkResponse} from '../models/search-paginated-adx-booking-to-trams-invoice-link-response';

@Injectable({
  providedIn: 'root'
})

export class AdxBookingToTramsInvoiceLinkGridService implements GridGetService<SearchPaginatedAdxBookingToTramsInvoiceLinkResponse> {
  private readonly baseUrl = 'dbov2/adx-booking-to-trams-invoice-link';
  private readonly http = inject(HttpClient);

  getItems({filters, page, sort} : GridServiceParams): Observable<GridServiceResponse<SearchPaginatedAdxBookingToTramsInvoiceLinkResponse>>  {
    const params:Record<string, string | number | boolean> = {
      pageSize:  page?.pageSize || 25,
      pageNumber : (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',

      tripId: filters?.['tripId'] ?? '',
    };

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<SearchPaginatedAdxBookingToTramsInvoiceLinkResponse>>(`${this.baseUrl}`, { params: {...params} })
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
    }));
  }

  updateIsEligible(payload: { id: number; isEligible: boolean }): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/update-booking-is-eligible`,
      payload
    ).pipe(catchError((error: HttpErrorResponse) => {
      throw new Error(error?.message || 'Server error');
    }));
  }
}